import { render, staticRenderFns } from "./LgFormInput.vue?vue&type=template&id=47634825&scoped=true"
import script from "./LgFormInput.vue?vue&type=script&lang=js"
export * from "./LgFormInput.vue?vue&type=script&lang=js"
import style0 from "./LgFormInput.vue?vue&type=style&index=0&id=47634825&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47634825",
  null
  
)

export default component.exports